//#region src/values/TextAlignment.ts
var e = {
	LEFT: "left",
	CENTER: "center",
	RIGHT: "right"
};
//#endregion
export { e as TEXT_ALIGNMENT };

//# sourceMappingURL=TextAlignment.js.map